import SEOHelmet from '@/components/SEOHelmet';
import { LLMService } from '@/services/llm.service';
import { useQuery } from '@tanstack/react-query';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '@/components/LoadingSpinner';
import CheckIcon from '@/assets/icons/check.svg?react';
import styles from './confirmation.module.scss';
import { classnames } from '@/utils/functions';
const Confirmation = () => {
  const { search } = useLocation();
  // get all params from search
  const params = new URLSearchParams(search);
  const code = params.get('code');
  const state = params.get('session_state');
  const { isFetched } = useQuery({
    queryKey: ['confirm-connection'],
    queryFn: async () => {
      if (!code || !state) {
        return false;
      }
      const success = await LLMService.sendSharepointCode(code);
      return success;
    },
    retry: false,
    enabled: !!code && !!state,
  });

  if (!code || !state) {
    return <Navigate to="/" state={{ from: 'confirmation' }} />;
  }
  const iconClassName = styles['icon'];

  return (
    <div className={styles['confirmation']}>
      <SEOHelmet title="Confirmation" index={false} />

      <section>
        <h1>Setting up Sharepoint Integration</h1>
        {isFetched ? (
          <>
            <CheckIcon
              className={classnames(iconClassName, styles['check-icon'])}
            />
            <p>
              Sharepoint has been successfully connected to your GANNET
              Workspace. <strong>You can now close this tab.</strong>
            </p>
          </>
        ) : (
          <>
            <LoadingSpinner className={iconClassName} />
            <p>Please wait a moment...</p>
          </>
        )}
      </section>
    </div>
  );
};

export default Confirmation;
